import React, { type ComponentPropsWithoutRef, type FC } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { virtualAgentOnboardingResource } from '@atlassian/jira-router-resources-service-desk-virtual-agent/src/onboarding/index.tsx';
import { VirtualAgentSidebar, VirtualAgentMenuItem } from './main.tsx';

export const VirtualAgent: FC<{
	projectKey: string;
	overrides: ComponentPropsWithoutRef<typeof VirtualAgentSidebar>['overrides'];
	shifter?: {
		groupTitle: string;
		context: string;
		weight: number;
	};
}> = ({ projectKey, overrides, shifter }) => {
	const { queryReference } = useRelayResource(virtualAgentOnboardingResource);

	if (queryReference == null) {
		// Some JSM settings pages don't have the VA onboarding resource defined in their resources list (mostly legacy pages)
		// For these pages, we'll just show the menu item (no nested nav) regardless of if they have a VA
		// In FLUX-8640 we'll change this to use an entry point so we can load in our FE & data async
		return <VirtualAgentMenuItem projectKey={projectKey} />;
	}

	return (
		<Placeholder
			name="virtual-agent-sidebar-item"
			fallback={<VirtualAgentMenuItem projectKey={projectKey} />}
		>
			<VirtualAgentSidebar
				projectKey={projectKey}
				overrides={overrides}
				shifter={shifter}
				queryReference={queryReference}
			/>
		</Placeholder>
	);
};
